// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Questions/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Leads_Content_Content_Questions($configuration_id: uuid!) {
  leads_questions(
    where: { configuration_id: { _eq: $configuration_id } }
    order_by: { order: asc }
  ) {
    id
    name
    prompt
    subprompt
    type
    options
    order
    required
    configuration_id
    status
    depends_on
    resource_table
    resource_id
    resource_schema
    external_resource
  }
}

`